export const Insurance_Providers_Options = [
  'Aetna',
  'Anthem',
  'Blue Cross',
  'Centene',
  'Cigna',
  'Health Care Service Corporation',
  'Molina Healthcare',
  'United Healthcare'
];

export const mailTo = 'mailto:insights@parsleyhealth.com';
